<template>
  <div>
    <DataTable
      title="KeyWords"
      @edit_click="editClick"
      :fields="fields"
      :response="getKeyWords"
      :is_createable="false"
      :show_delete="false"
      :show_header_filter="false"
       />
  </div>
</template>
<script>
// imports
import { mapActions, mapMutations, mapGetters } from 'vuex'
import DataTable from '@/components/DataTable.vue'

// exports
export default {
  name: 'KeyWordsPage',
  components: {
    DataTable
  },
  data () {
    return {
      fields: [
        {
          name: 'Content',
          component: 'TableCellFormattedText'
        }
      ]
    }
  },
  computed: {
    ...mapGetters('settings', ['getKeyWords'])
  },
  created () {
    this.fetchSettings()
  },
  methods: {
    ...mapActions('settings', ['fetchSettings']),
    ...mapMutations('modals', ['create']),
    editClick (data) {
      this.create({
        designator: 'key-words-upsert-modal',
        component_name: 'KeyWordsUpsert',
        data,
        modal_title: `Key Words Planner`
      })
    }
  }
}
</script>
